import { connect } from 'react-redux';
import React, { Component, Fragment } from 'react';
import {actions as project} from './reducers/project';
import {actions as language} from './reducers/language';
import {actions as system} from './reducers/system';
import {actions as labelCollection} from './reducers/labelCollection';
import {actions as label} from './reducers/label';
import Sidebar from './components/main/Sidebar';
import Footer from './components/main/Footer';
import Message from './components/main/Message';
import Loading from './components/main/Loading';
import Navbar from './components/main/Navbar';
import { withRouter } from 'react-router-dom';
import * as routing from './services/routing';
import _ from 'lodash';
import {HotKeys} from "react-hotkeys";

@connect(
	state => {
		return {
			projects: state.project.projects,
			isLoading: state.system.isLoading,
			messages: state.system.messages,

			selectedProject: state.project.selected,
			selectedLanguage: state.language.selected,
			selectedLabelCollection: state.labelCollection.selected,
			selectedLabel: state.label.selected,
		}
	},
	dispatch => {
		return {
			selectProject: (projectIdentifier) => dispatch(project.select(projectIdentifier)),
			resetSelectedProject: () => dispatch(project.resetSelected()),
			selectLanguage: (languageIdentifier) => dispatch(language.select(languageIdentifier)),
			resetSelectedLanguage: () => dispatch(language.resetSelected()),
			selectLabelCollection: (labelCollectionIdentifier) => dispatch(labelCollection.select(labelCollectionIdentifier)),
			resetSelectedLabelCollection: () => dispatch(labelCollection.resetSelected()),
			selectLabel: (labelCollectionIdentifier) => dispatch(label.select(labelCollectionIdentifier)),
			resetSelectedLabel: () => dispatch(label.resetSelected()),

			fetchProjects: () => dispatch(project.fetch()),
			removeMessage: (message) => dispatch(system.removeMessage(message)),
			clearMessages: () => dispatch(system.clearMessages())
		};
	})
class App extends Component
{

	constructor(props){
		super(props);

		this.setSelectedByLocation(props.location);
		props.history.listen(location => {
			this.setSelectedByLocation(location);
		});
	}

	componentDidMount() {
		this.props.fetchProjects()
			.then(() => {
				if(this.props.location.pathname === '/' && this.props.projects.length) {
					this.props.history.push('/show/' + encodeURIComponent(_.head(this.props.projects).name));
				}
			});
	}

	setSelectedByLocation(location) {
		const params = routing.getParamsByLocation(location);

		const handleLanguage = () => {
			if(_.has(params, 'language')){
				const languageToSelect = _.get(params, 'language');
				if(this.props.selectedLanguage === null || languageToSelect !== encodeURIComponent(this.props.selectedLanguage.identifier)) {
					this.props.selectLanguage(languageToSelect);
				}
			} else {
				if(this.props.selectedLanguage) {
					this.props.resetSelectedLanguage();
				}
			}
		};

		const handleProject = () => {
			if(_.has(params, 'project')){
				const projectToSelect = _.get(params, 'project');
				if(this.props.selectedProject === null || projectToSelect !== encodeURIComponent(this.props.selectedProject.name)) {
					this.props.selectProject(projectToSelect)
						.then(handleLabelCollection);
				}
			} else {
				if(this.props.selectedProject) {
					this.props.resetSelectedProject();
				}
			}
		};

		const handleLabelCollection = () => {
			if(_.has(params, 'labelCollection')){
				if(this.props.selectedProject) {
					const labelCollectionToSelect = _.get(params, 'labelCollection');
					if (this.props.selectedLabelCollection === null || labelCollectionToSelect !== encodeURIComponent(this.props.selectedLabelCollection.identifier)) {
						this.props.selectLabelCollection(labelCollectionToSelect)
							.then(handleLabel);
					}
				}
			} else {
				if(this.props.selectedLabelCollection) {
					this.props.resetSelectedLabelCollection();
				}
			}
		};

		const handleLabel = () => {
			if(_.has(params, 'label')){
				if(this.props.selectedLabelCollection !== null) {
					const labelToSelect = _.get(params, 'label');
					if (this.props.selectedLabel === null || labelToSelect !== encodeURIComponent(this.props.selectedLabel.name)) {
						this.props.selectLabel(labelToSelect);
					}
				}
			} else {
				if(this.props.selectedLabel) {
					this.props.resetSelectedLabel();
				}
			}
		};

		handleLanguage();
		handleProject();
		handleLabelCollection();
		handleLabel();
	}

	render() {
		return (
			<HotKeys keyMap={keyMap}>
				<Fragment>
					<div className="wrapper">
						<Sidebar {...this.props}/>
						<div className="main-panel">
							<Navbar />

							<div className="content">
								{routing.renderScreenRoutes()}
							</div>


							<Message messages={this.props.messages} remove={this.props.removeMessage} clear={this.props.clearMessages} />
						</div>
					</div>
					<Loading show={!!this.props.isLoading} />
				</Fragment>
			</HotKeys>
		);
	}
}

const keyMap = {
	SAVE_LABEL: "ctrl+s",
	SAVE_AND_NEW: "ctrl+shift+s"
};

export default withRouter(App);



// WEBPACK FOOTER //
// ./React/src/App.js